import React from 'react';

import { ExpLabel } from '@exp/components/localization';

import VetsBrands from '../images/vets/vetsbrands.png';

import './VetsTeasers.less';

const VetBullets = () => (
  <ul className="va-tease-items">
    <li>
      <i className="exp-ux-small exp-ux-arrow-right" />
      <ExpLabel messageKey="onb.application.vetsTease1" defaultMessage="Get $20 off your first order instantly" />
    </li>
    <li>
      <i className="exp-ux-small exp-ux-arrow-right" />
      <ExpLabel messageKey="onb.application.vetsTease2" defaultMessage="Get up to 60% off top brands" />
    </li>
    <li>
      <i className="exp-ux-small exp-ux-arrow-right" />
      <ExpLabel messageKey="onb.application.vetsTease3" defaultMessage="New Flash Deals each week" />
    </li>
  </ul>
);

const VetTeasers = ({ onlyBullets = false }: { onlyBullets?: boolean }) => {
  if (onlyBullets) {
    return <VetBullets />;
  }
  return (
    <div className="vets-teasers">
      <VetBullets />
      <ExpLabel className="price" messageKey="onb.application.vetsOffer" defaultMessage="Up to 60% off" tagName="h4" />
      <ExpLabel messageKey="onb.application.vetsGear" defaultMessage="gear for every adventure" tagName="h4" />
      <img className="brand-tease" src={VetsBrands} alt="Shop your favorite brands" />
    </div>
  );
};

VetTeasers.displayName = 'VetTeasers';

export default VetTeasers;
